<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <v-layout row wrap>
      <v-flex xs12 md8 lg8 class="mb-2">
        <v-layout
          row
          v-if="hasDocs"
          :wrap="mobile"
          align-center
          justify-space-between
          class="pl-0 pr-0 mb-2"
        >
          <v-tabs class="page__tabs opaque" hide-slider v-model="selectedTab">
            <v-tab
              v-for="(tab, i) in tabs"
              :to="tab.value"
              :key="i"
              active-class="docs--background white--text"
            >
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <template v-if="selectedTab === generalString">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <select-field
              label=""
              class="document__visualized-filter"
              v-model="generalVisualizedFilter"
              :items="generalFilterValues"
              selectKeyName="value"
              selectValueName="text"
            ></select-field>
          </template>
          <template v-if="selectedTab === legalString">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <select-field
              label=""
              class="document__visualized-filter"
              v-model="legalVisualizedFilter"
              :items="legalFilterValues"
              selectKeyName="value"
              selectValueName="text"
            ></select-field>
          </template>
        </v-layout>
        <screen-loading v-if="docsLoading && !hasDocs"></screen-loading>
        <div v-else>
          <geral-doc-list
            class="pl-1"
            v-if="selectedTab === generalString"
            :items="generalDocs"
            @previewFile="
              (v) => {
                previewFile(v, 'general');
              }
            "
            :themeColor="pageParams.themeColor"
            :emptyState="pageParams.emptyState"
            :visualizedFilter="generalVisualizedFilter"
            :error="docsError"
          >
          </geral-doc-list>
          <legal-doc-list
            class="pl-1"
            :params="enums.legalDocuments"
            :themeColor="pageParams.themeColor"
            :emptyState="pageParams.emptyState"
            v-if="selectedTab === legalString"
            :items="legalDocs"
            @previewFile="
              (v) => {
                previewFile(v, 'legal');
              }
            "
            :statusParams="enums.legalDocumentsStatus"
            :visualizedFilter="legalVisualizedFilter"
            :error="docsError"
          >
          </legal-doc-list>
          <div v-if="docsError" class="empty-state">
            {{ enums.responses.error }}
          </div>
          <div v-else-if="!selectedTab" class="empty-state">
            {{ pageParams.emptyState }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 md4 lg4 :class="`mb-4 ${!mobile ? 'mt-2' : 'mt-4'}`">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="enums.responses.error"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import FaqCard from '@/components/modules/FaqCard';
import SelectField from '@/components/fields/Select';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import GeralDocList from '@/components/document/GeralDocList';
import LegalDocList from '@/components/document/LegalDocList';
import faqMixin from '@/mixins/modules/faq';
import docsMixin from '@/mixins/modules/docs';
import bus from '@/utils/bus';
import { APP, DOCS, NOTIFICATIONS } from '@/utils/constants';
import notificationTypes from '@/utils/notificationTypes';

export default {
  name: 'documents',
  mixins: [faqMixin, docsMixin],
  components: {
    ModulePage,
    FaqCard,
    SelectField,
    ScreenLoading,
    GeralDocList,
    LegalDocList,
  },
  computed: {
    customBreadcrumbs() {
      return [{ text: 'Documentos' }, { text: this.pageParams.title }];
    },
    tabs() {
      return this.pageParams.tabs.filter((tab) => {
        return (
          (tab.value === this.legalString && this.hasLegalDocs) ||
          tab.value !== this.legalString
        );
      });
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].enterpriseDocs,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      selectedTab: '',

      generalString: 'geral',
      legalString: 'legal',

      docs: {},

      faqs: [],
      faqsLoading: false,
      faqsError: false,

      generalVisualizedFilter: null,
      legalVisualizedFilter: null,
      generalFilterValues: [
        { text: 'Todos', value: null },
        { text: 'Lido', value: true },
        { text: 'Não Lido', value: false },
      ],
      legalFilterValues: [
        { text: 'Todos', value: null },
        { text: 'Concluído', value: 1 },
        { text: 'Em Andamento', value: 2 },
        { text: 'Não Iniciado', value: 3 },
      ],
    };
  },
  created() {
    bus.$on('unit:change', this.getDocuments);
    bus.$on('unit:update', this.getDocuments);

    this.selectedTab = this.$route.params.type;

    this.getDocuments();
    this.getFaqs();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getDocuments);
    bus.$off('unit:update', this.getDocuments);
  },
  methods: {
    previewFile({ title, attachment, _id }, type) {
      window.open(attachment, '_blank');

      const notificationInfo = {
        ctx: this,
        notification: {
          id: _id,
          type: notificationTypes[`${type.toUpperCase()}_DOCS`],
        },
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);

      const action = this.enums.logTraceActions[`${type}DocsDownload`];
      this.createTrace(action, { title, attachment });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.document {
  &__visualized-filter {
    padding: 0px;

    >>> .v-input__slot {
      width: 200px;
      @include breakpoint(not-mobile) {
        margin-left: auto;
        margin-right: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/document/EnterpriseDocuments.vue